<template>
    <!--首页固定左侧广告-->
    <div class="wrapper">
        <div class="fixed-wrapA" :style="{top: scrollTop + 'px'}">
            <div v-show="showLogin1">
                <div v-if="ad_onelink1.type&&ad_onelink1.type===2">
                    <el-button class="close" style="left:0;" icon="el-icon-close" @click="showLogin1=false"></el-button>
                    <a :href="ad_onelink1.dirlink" target="_blank">
                        <img class="fixed-img" :src="ad_onelink1.logo" alt>
                    </a>
                </div>
                <div v-if="ad_onelink1.type&&ad_onelink1.type===1">
                    <a :href="ad_onelink1.dirlink" target="_blank">
                        <!--<img class="fixed-img" :src="ad_onelink1.logo" alt="">-->
                        <object data type>
                            <embed class="fixed-img" :src="ad_onelink1.logo" type>
                        </object>
                    </a>
                </div>
            </div>

            <div style="position: relative" v-show="showLogin11">
                <div v-if="ad_onelink2.type&&ad_onelink2.type===2">
                    <el-button class="close1" style="left:0;" icon="el-icon-close"
                               @click="showLogin11=false"></el-button>
                    <a :href="ad_onelink2.dirlink" target="_blank">
                        <img class="fixed-img" :src="ad_onelink2.logo" alt>
                    </a>
                </div>
                <div v-if="ad_onelink2.type&&ad_onelink2.type===1">
                    <a :href="ad_onelink2.dirlink" target="_blank">
                        <!--<img class="fixed-img" :src="ad_onelink2.logo" alt="">-->
                        <object data type>
                            <embed class="fixed-img" :src="ad_onelink2.logo" type>
                        </object>
                    </a>
                </div>
            </div>
        </div>

        <!--首页右侧广告-->
        <div class="fixed-wrapB" :style="{top: scrollTop + 'px'}">
            <div v-show="showLogin2">
                <div v-if="ad_twolink1.type&&ad_twolink1.type===2">
                    <el-button class="close" icon="el-icon-close" @click="showLogin2=false"></el-button>

                    <a :href="ad_twolink1.dirlink" target="_blank">
                        <img class="fixed-img" :src="ad_twolink1.logo" alt>
                    </a>
                </div>
                <div v-if="ad_twolink1.type&&ad_twolink1.type===1">
                    <a :href="ad_twolink1.dirlink" target="_blank">
                        <!--<img class="fixed-img" :src="ad_onelink1.logo" alt="">-->
                        <object data type>
                            <embed class="fixed-img" :src="ad_twolink1.logo" type>
                        </object>
                    </a>
                </div>
            </div>
            <!--<el-button class="close" icon="el-icon-close" @click="showLogin2=false"></el-button>-->

            <div v-show="showLogin22" style="position: relative;">
                <div v-if="ad_twolink2.type&&ad_twolink2.type===2">
                    <el-button class="close" style="top:3px;" icon="el-icon-close"
                               @click="showLogin22=false"></el-button>
                    <a :href="ad_twolink2.dirlink" target="_blank">
                        <img class="fixed-img" :src="ad_twolink2.logo" alt>
                    </a>
                </div>
                <div v-if="ad_twolink2.type&&ad_twolink2.type===1">
                    <a :href="ad_twolink2.dirlink" target="_blank">
                        <!--<img class="fixed-img" :src="ad_twolink2.logo" alt="">-->
                        <object data type>
                            <embed class="fixed-img" :src="ad_twolink2.logo" type>
                        </object>
                    </a>
                </div>
            </div>
        </div>

        <!--弹窗广告-->
        <div class="tanchuangWrap" v-if="pop.is_ad==1" v-show="showSign">
            <!---->
            <div class="tanchuang">
                <el-button class="close-center" icon="el-icon-close" @click="closeImg()"></el-button>
                <a :href="pop.ad_dir" target="_blank">
                    <img :src="pop.ad_img" alt>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FixedGuanggao",

        data() {
            return {
                ad_one: [],
                ad_two: [],
                ad_onelink1: [],
                ad_onelink2: [],
                ad_twolink1: [],
                ad_twolink2: [],
                pop: "",
                showSign: true,
                showLogin1: true, // 显示关闭按钮
                showLogin11: true,
                showLogin2: true, // 显示关闭按钮
                showLogin22: true, // 显示关闭按钮
                scrollTop: 0
            };
        },
        methods: {
            closeImg() {
                this.showSign = false;
                localStorage.setItem("guanggao", "1");
            },
            guangGao() {
                this.$get(this.ServicesApi.ad_position)
                    .then(res => {
                        if (res.code === 0) {
                            this.ad_one = res.data.ad_one;
                            this.ad_two = res.data.ad_two;
                            if (res.data.ad_one[0]) {
                                this.ad_onelink1 = res.data.ad_one[0];
                            }
                            if (res.data.ad_one[1]) {
                                this.ad_onelink2 = res.data.ad_one[1];
                            }
                            if (res.data.ad_two[0]) {
                                this.ad_twolink1 = res.data.ad_two[0];
                            }
                            if (res.data.ad_two[1]) {
                                this.ad_twolink2 = res.data.ad_two[1];
                            }
                            if (res.data.pop_ad) {
                                this.pop = res.data.pop_ad;
                            }
                            console.log(res.data, "弹出广告");
                            console.log(this.pop);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            handleScroll() {
                this.scrollTop = document.documentElement.scrollTop;
            }
        },
        mounted() {
            window.addEventListener("scroll", this.handleScroll);
            document.documentElement.scrollTop = 800;
        },
        created() {
            this.guangGao();
            // let guanggao = localStorage.getItem('guanggao')
            // if (guanggao) {
            //   this.showSign = false
            // } else {
            //   this.showSign = true
            // }
        }
    };
</script>

<style scoped lang="less">
    /*.close{*/
    /*display:none;*/
    /*}*/
    /*@media (max-width: 1500px) {*/
    /*.close{*/
    /*display:block;*/
    /*}*/

    /*}*/

    .close,
    close2 {
        left: 147px;
        position: absolute;
        top: 12px;
        left: 150px;
        line-height: 50%;
        text-align: center;
        /*height: 20px;*/
        /*width: 20px;*/
        font-size: 18px;
        padding: 1px;
        cursor: pointer;
        border: none;
    }

    .close1 {
        position: absolute;
        top: 0px;
        left: 148px;
        line-height: 50%;
        text-align: center;
        /*height: 20px;*/
        /*width: 20px;*/
        font-size: 18px;
        padding: 1px;
        cursor: pointer;
        border: none;
    }

    .close-center {
        left: 961px;
        position: absolute;
        top: 0;
        line-height: 50%;
        text-align: center;
        /*height: 20px;*/
        /*width: 20px;*/
        font-size: 27px;
        padding: 1px;
        cursor: pointer;
        border: none;
    }

    .tanchuangWrap {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999;
        background: rgba(0, 0, 0, 0.5);
    }

    .tanchuang {
        width: 990px;
        height: 600px;
        margin: 0 auto;
        position: relative;
        background: #ffffff;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .fixed-wrapA {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999999;
        transition: 0.3s;
    }

    .fixed-wrapB {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 999999;
        transition: 0.3s;
    }

    .fixed-wrapA > div {
        margin-top: 10px;
    }

    .fixed-wrapB > div {
        margin-top: 10px;
    }

    .fixed-img {
        width: 170px;
        height: 209px;
    }
</style>
